"use client";

import dynamic from "next/dynamic";
import { useEffect, type ReactNode } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { captureUtms } from "@/utils/utm";
import patchDomReconciliation from "@/utils/patchDomReconciliation";

patchDomReconciliation();

const PrimaryNavigation = dynamic(
  () => import("@/templates/PrimaryNavigation"),
  { ssr: false },
);

const Footer = dynamic(() => import("@/templates/Footer"), { ssr: false });

interface ClientLayoutProps {
  navData?: any;
  footerData?: any;
  locale?: string;
  children: ReactNode;
}

export default function ClientLayout({
  navData,
  footerData,
  locale,
  children,
}: ClientLayoutProps) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    captureUtms();
  }, [pathname, searchParams]);

  return (
    <>
      <PrimaryNavigation data={navData} locale={locale} />
      {children}
      <Footer data={footerData} locale={locale} />
    </>
  );
}
